removePathQuery